import React from 'react';

const WalletGroupBadge = ({ group, size = 'md', showName = true, onClick }) => {
  // Determine text color for best contrast
  const getContrastTextColor = (hexColor) => {
    if (!hexColor || hexColor === '') return '#FFFFFF';
    
    // Remove the # if it's there
    const hex = hexColor.replace('#', '');
    
    // Convert to RGB
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    
    // Calculate luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    
    // Return black for light colors, white for dark
    return luminance > 0.5 ? '#000000' : '#FFFFFF';
  };
  
  // Get badge style
  const getBadgeStyle = () => {
    return {
      backgroundColor: group?.color || '#4C6FFF',
      color: getContrastTextColor(group?.color || '#4C6FFF')
    };
  };
  
  // Get size class
  const getSizeClass = () => {
    switch (size) {
      case 'xs':
        return 'h-3 w-3';
      case 'sm':
        return 'h-4 w-4 text-xs';
      case 'lg':
        return 'h-6 w-6 text-sm';
      case 'xl':
        return 'h-8 w-8 text-base';
      default: // md
        return 'h-5 w-5 text-xs';
    }
  };
  
  if (!group) {
    return null;
  }
  
  if (!showName) {
    return (
      <span 
        className={`${getSizeClass()} rounded-full inline-block flex-shrink-0 ${onClick ? 'cursor-pointer' : ''}`}
        style={getBadgeStyle()}
        onClick={onClick}
        title={group.name}
      ></span>
    );
  }
  
  return (
    <div 
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 ${onClick ? 'cursor-pointer' : ''}`}
      style={getBadgeStyle()}
      onClick={onClick}
    >
      <span className={`rounded-full ${getSizeClass()} mr-1.5`} style={getBadgeStyle()}></span>
      <span className="text-xs font-medium">{group.name}</span>
      {group.wallet_count !== undefined && (
        <span className="ml-1 text-xs opacity-80">({group.wallet_count})</span>
      )}
    </div>
  );
};

export default WalletGroupBadge;